import IOTA from '@iota/validators';

function isValidIotaAddress(address, currency, networkType) {
    return IOTA.isAddress(address);
}

export default {
    isValidAddress(address, currency, networkType) {
        return isValidIotaAddress(address, currency, networkType);
    },
};
